export default __webpack_public_path__ + "static/media/choose-out.6cf9a50f.wav";